import styled from 'styled-components'

const MOBILE_BP = '930px'

export const ViewerRoot = styled.div`
    margin-top: 8px;

    .viewer-page-title {
        font-size: 18px;
        font-weight: 700;
        color: #1a2744;
    }

    .viewer-page-subtitle {
        font-size: 13px;
        color: #6b7a9e;
        margin-top: 3px;
    }

    .viewer-stats {
        display: flex;
        gap: 12px;
        flex-wrap: wrap;
        margin-bottom: 20px;
    }

    .viewer-stat-card {
        flex: 1;
        min-width: 120px;
        background: #fff;
        border: 1px solid #dde2f0;
        border-radius: 12px;
        padding: 14px 18px;
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .viewer-filters {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
        margin-bottom: 12px;
        align-items: center;
    }

    .viewer-filter-field {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .viewer-filter-label {
        font-size: 12px;
        font-weight: 500;
        color: #6b7a9e;
        white-space: nowrap;
    }

    .viewer-search-wrap {
        position: relative;
    }

    .viewer-search-icon {
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);
        color: #6b7a9e;
        font-size: 14px;
        pointer-events: none;
    }

    .viewer-search-input {
        height: 36px;
        border: 1px solid #dde2f0;
        border-radius: 8px;
        padding-left: 32px;
        padding-right: 12px;
        font-size: 13px;
        color: #1a2744;
        background: #fff;
        outline: none;
        width: 200px;
    }

    .viewer-select {
        height: 36px;
        border: 1px solid #dde2f0;
        border-radius: 8px;
        padding: 0 12px;
        font-size: 13px;
        color: #1a2744;
        background: #fff;
        outline: none;
        min-width: 140px;
    }

    .viewer-month-bar {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
        margin-bottom: 14px;
        padding: 12px 16px;
        background: #fff;
        border: 1px solid #dde2f0;
        border-radius: 10px;
    }

    .viewer-month-label {
        font-size: 12px;
        font-weight: 600;
        color: #1a2744;
        white-space: nowrap;
    }

    .viewer-month-picker {
        min-width: 200px;
        max-width: 240px;
        flex: 1;
    }

    .viewer-btn-primary {
        height: 34px;
        padding: 0 16px;
        background: #2d4fbd;
        color: #fff;
        border: none;
        border-radius: 7px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;

        &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }
    }

    .viewer-btn-ghost {
        height: 32px;
        padding: 0 12px;
        border: 1px solid #dde2f0;
        border-radius: 7px;
        background: #f4f6fb;
        color: #6b7a9e;
        font-size: 12px;
        font-weight: 500;
        cursor: pointer;
    }

    .viewer-legend {
        display: flex;
        gap: 16px;
        margin-bottom: 16px;
        flex-wrap: wrap;
    }

    .viewer-legend-item {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        color: #6b7a9e;
    }

    .viewer-auditor-list {
        display: flex;
        flex-direction: column;
        gap: 14px;
    }

    .viewer-auditor-card {
        background: #fff;
        border: 1px solid #dde2f0;
        border-radius: 10px;
        overflow: hidden;
    }

    .viewer-auditor-card.is-inactive {
        opacity: 0.6;
    }

    .viewer-auditor-header {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 16px;
        background: #f7f9fc;
        border-bottom: 1px solid #dde2f0;
        flex-wrap: wrap;
    }

    .viewer-avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        font-size: 13px;
        flex-shrink: 0;
    }

    .viewer-auditor-name {
        font-weight: 700;
        font-size: 15px;
        color: #1a2744;
    }

    .viewer-inactive-badge {
        margin-left: 8px;
        font-size: 11px;
        font-weight: 600;
        padding: 2px 8px;
        border-radius: 10px;
        background: #fee2e2;
        color: #b91c1c;
    }

    .viewer-auditor-meta {
        font-size: 12px;
        color: #6b7a9e;
        margin-top: 2px;
    }

    .viewer-schedule-header {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 8px 16px;
        background: #f0fdf4;
        border-bottom: 1px solid #f1f5f9;
        flex-wrap: wrap;
    }

    .viewer-schedule-title {
        flex: 1;
        min-width: 0;
        font-size: 12px;
        font-weight: 600;
        color: #166534;
    }

    .viewer-shift-pill {
        background: #e0f2fe;
        color: #0369a1;
        padding: 2px 10px;
        border-radius: 12px;
        font-size: 11px;
        font-weight: 600;
    }

    .viewer-week-table {
        width: 100%;
        border-collapse: collapse;
    }

    .viewer-week-label-cell {
        padding: 8px 16px;
        border-bottom: 1px solid #f1f5f9;
        font-size: 13px;
        width: 130px;
        vertical-align: top;
    }

    .viewer-week-label-cell.is-partial {
        color: #92400e;
        background: #fef3c7;
        font-weight: 600;
    }

    .viewer-week-dates-cell {
        padding: 8px 16px;
        border-bottom: 1px solid #f1f5f9;
        font-size: 13px;
        font-weight: 500;
        color: #1a2744;
    }

    .viewer-week-place-cell {
        padding: 8px 16px;
        border-bottom: 1px solid #f1f5f9;
        font-size: 13px;
    }

    .viewer-place-chip {
        display: inline-block;
        padding: 2px 10px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 600;
    }

    .viewer-place-chip.is-changed {
        background: #fef3c7;
        color: #92400e;
    }

    .viewer-place-chip.is-default {
        background: #ede9fe;
        color: #5b21b6;
    }

    .viewer-week-comments {
        padding: 0 16px 8px;
        font-size: 12px;
        color: #6b7a9e;
        font-style: italic;
        border-bottom: 1px solid #f1f5f9;
    }

    .viewer-empty {
        text-align: center;
        padding: 60px 24px;
        color: #6b7a9e;
    }

    .viewer-empty-icon {
        font-size: 48px;
        margin-bottom: 12px;
    }

    .viewer-empty-text {
        font-size: 15px;
    }

    @media (max-width: ${MOBILE_BP}) {
        .viewer-stats {
            flex-direction: column;
        }

        .viewer-stat-card {
            min-width: 0;
            width: 100%;
        }

        .viewer-filters {
            flex-direction: column;
            align-items: stretch;
        }

        .viewer-filter-field {
            flex-direction: column;
            align-items: stretch;
            width: 100%;
        }

        .viewer-search-input,
        .viewer-select {
            width: 100%;
            min-width: 0;
        }

        .viewer-month-bar {
            flex-direction: column;
            align-items: stretch;
        }

        .viewer-month-picker {
            min-width: 0;
            max-width: none;
            width: 100%;
        }

        .viewer-btn-primary,
        .viewer-btn-ghost {
            width: 100%;
        }

        .viewer-auditor-header {
            flex-direction: column;
            align-items: flex-start;
        }

        .viewer-week-table,
        .viewer-week-table tbody,
        .viewer-week-table tr {
            display: block;
            width: 100%;
        }

        .viewer-week-table tr.viewer-week-row {
            padding: 12px 16px 10px;
            border-bottom: 1px solid #f1f5f9;
        }

        .viewer-week-table tr.viewer-week-row:last-child {
            border-bottom: none;
        }

        .viewer-week-table td {
            display: block;
            width: 100% !important;
            padding: 0 !important;
            border-bottom: none !important;
        }

        .viewer-week-label-cell {
            margin-bottom: 6px;
            background: transparent !important;
            width: auto;
        }

        .viewer-week-label-cell.is-partial {
            display: inline-block;
            width: auto !important;
            padding: 2px 8px !important;
            border-radius: 4px;
            margin-bottom: 8px;
        }

        .viewer-week-dates-cell {
            margin-bottom: 8px;
            font-size: 14px;
        }

        .viewer-week-dates-cell::before {
            content: 'Dates';
            display: block;
            font-size: 10px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.4px;
            color: #6b7a9e;
            margin-bottom: 4px;
        }

        .viewer-week-place-cell {
            margin-bottom: 0;
        }

        .viewer-week-place-cell::before {
            content: 'Workplace';
            display: block;
            font-size: 10px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.4px;
            color: #6b7a9e;
            margin-bottom: 4px;
        }

        .viewer-week-comments-row {
            display: block;
            padding: 0 16px 12px;
            border-bottom: 1px solid #f1f5f9;
        }

        .viewer-week-comments-row .viewer-week-comments {
            padding: 0;
            border: none;
        }
    }
`
